import cn from 'classnames'
import { Button, BUTTON_TYPES } from 'components/Button'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { BTN_TXT } from 'constants/txt'
import { ReactComponent as Plus16 } from 'assets/svg/Plus16.svg'
import { CONTRACT_DOCUMENTS_LIMIT_TOOLTIP } from './constants'

type TAddContractButtonProps = {
  onClick: VoidFunction
  disabled?: boolean
  tooltipText?: string
}

export const AddContractButton = ({
  onClick,
  disabled,
  tooltipText = CONTRACT_DOCUMENTS_LIMIT_TOOLTIP
}: TAddContractButtonProps) => (
  <Tooltip
    title={tooltipText}
    overlayInnerStyle={{ display: disabled ? 'block' : 'none', width: 364 }}
    placement="topLeft"
  >
    <div className={cn({ 'add-contract-button--not-allowed': disabled })}>
      <Button
        type={BUTTON_TYPES.GHOST}
        icon={<Plus16 />}
        onClick={onClick}
        disabled={disabled}
        upperCase
      >
        {BTN_TXT.ADD_CONTRACT}
      </Button>
    </div>
  </Tooltip>
)
